import { render } from "./Steps-actions.vue?vue&type=template&id=be244dac"
import script from "./Steps-actions.vue?vue&type=script&lang=js"
export * from "./Steps-actions.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__